import addMonths from "date-fns/addMonths";
import isAfter from "date-fns/isAfter";
import setDayOfMonth from "@/helpers/setDayOfMonth";
import endOfDay from "date-fns/endOfDay";

/**
 * 請求に対する支払いのルール
 */
export default class BillingRule {
  constructor(
    private months: number,
    private dayOfMonth: number,
    private cutoffDate: number
  ) {}

  /**
   * 請求日から支払い期限を求める
   */
  getDueDate(billingDate: Date): Date {
    if (this.cutoffDate == null) {
      this.cutoffDate = 0;
    }

    if (this.months == null) {
      this.months = 0;
    }

    if (this.dayOfMonth == null) {
      this.dayOfMonth = 0;
    }
    const c = endOfDay(setDayOfMonth(billingDate, this.cutoffDate));
    const dm = isAfter(billingDate, c) ? this.months + 1 : this.months;
    const m = addMonths(billingDate, dm);

    return endOfDay(setDayOfMonth(m, this.dayOfMonth));
  }

  getDayOfMonth() {
    return this.dayOfMonth;
  }

  getCutoffDate() {
    return this.cutoffDate;
  }

  getMonths() {
    return this.months;
  }
}
